import type { IntlShape } from 'react-intl'
import { ServiceType } from '../../domain/types'

export function getServiceName(type: string, intl: IntlShape): string | undefined {
  const nameMappings: [string[], string][] = [
    [[ServiceType.CarRentalFiltering, 'AUTOHUUR*'], 'checkout_steps_ancillaries_car_rental_filtering_title'],
    [
      [ServiceType.TravelInsurance, ServiceType.TravelInsurancePerBooking, 'TRAVEL*'],
      'checkout_steps_ancillaries_travel_insurance_title',
    ],
    [
      [ServiceType.CancellationInsurance, ServiceType.CancellationInsurancePerBooking, 'CANCEL*'],
      'checkout_steps_ancillaries_cancellation_insurance_title',
    ],
    [[ServiceType.MealplanDP, 'ACCOMMODATION'], 'checkout_steps_ancillaries_mealplan_dp_title'],
    [[ServiceType.BookingRedeem, 'REDEEM'], 'checkout_steps_ancillaries_booking_redeemer_title'],
    [[ServiceType.Luggage, 'LUG_*'], 'checkout_steps_ancillaries_luggage_title'],
    [[ServiceType.SkiPass], 'checkout_steps_ancillaries_ski_pass_title'],
    [[ServiceType.SkiMaterial], 'checkout_steps_ancillaries_ski_material_title'],
    [[ServiceType.SkiLesson], 'checkout_steps_ancillaries_ski_lesson_title'],
    [[ServiceType.Sweater, 'SWEATER*'], 'checkout_steps_clothing_sweater_title'],
    [[ServiceType.TShirt, 'TSHIRT*'], 'checkout_steps_clothing_tshirt_title'],
    [[ServiceType.Bus, 'BUS'], 'checkout_steps_ancillaries_bus_title'],
    [[ServiceType.Golf, 'GREENFEE'], 'checkout_steps_ancillaries_golf_title'],
    [[ServiceType.DinnerVouchers, 'MEAL-VOUCHERS'], 'checkout_steps_ancillaries_dinner_vouchers_title'],
    [[ServiceType.Bridge, 'BRIDGE'], 'checkout_steps_ancillaries_bridge_title'],
  ]

  for (const [types, messageId] of nameMappings) {
    if (types.includes(type)) {
      return intl.formatMessage({ id: messageId })
    }
  }

  return undefined
}
